var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketLaunch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_60137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9561 98.3045C59.2682 97.382 59.5095 96.4311 59.8784 95.5511C65.7246 81.8696 74.1959 69.948 84.1429 58.963C93.2243 48.9431 103.952 41.336 116.325 35.9428C117.546 35.4177 118.198 35.588 119.106 36.5105C133.878 51.3416 148.678 66.1444 163.506 80.9187C164.429 81.8412 164.57 82.5083 164.06 83.7004C157.547 99.156 147.06 111.461 134.133 121.892C125.109 129.173 115.559 135.602 104.931 140.328C101.653 141.79 100.007 141.506 97.4529 138.952C85.3774 126.888 73.3161 114.824 61.2406 102.775C60.0061 101.54 59.0696 100.192 58.9561 98.3045ZM135.41 82.9766C135.439 72.7581 127.28 64.5832 117.063 64.5832C106.932 64.5832 98.7442 72.7155 98.6874 82.8205C98.6306 92.9965 106.832 101.285 116.978 101.313C127.18 101.342 135.396 93.181 135.41 82.9766Z",
    fill: "url(#paint0_linear_121_60137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5633 103.683C44.3691 102.647 37.4303 101.625 30.4773 100.689C28.0792 100.362 26.1494 99.4822 25.3264 97.0695C24.5034 94.6852 25.369 92.755 27.1143 91.0377C32.0098 86.2123 36.8343 81.3301 41.7014 76.4763C48.8389 69.3375 57.4379 65.3352 67.4984 64.4411C67.9809 64.3985 68.4775 64.3843 68.9741 64.3701C69.3431 64.3701 69.7262 64.3701 70.4499 64.3701C69.7971 65.25 69.3005 65.9171 68.7897 66.5983C62.6597 74.7874 57.452 83.5157 53.4505 92.9395C51.1092 98.4462 52.0032 103.399 56.2175 107.615C68.3214 119.721 80.4253 131.827 92.5433 143.933C97.0982 148.489 102.008 149.355 107.897 146.715C116.879 142.684 125.208 137.546 133.069 131.628C133.85 131.046 134.63 130.464 135.396 129.882C135.567 129.925 135.751 129.968 135.921 130.01C135.467 133.019 135.184 136.085 134.502 139.037C132.8 146.374 129.153 152.69 123.86 158.026C118.865 163.064 113.828 168.046 108.833 173.07C107.145 174.773 105.215 175.497 102.902 174.688C100.561 173.865 99.6666 172.006 99.3544 169.664C98.4037 162.667 97.3678 155.684 96.3462 148.503C95.6367 149.056 95.1117 149.496 94.5583 149.908C89.152 154.01 81.5605 153.839 76.6934 149.099C67.9808 140.612 59.3819 132.011 50.9106 123.311C46.2279 118.514 46.0435 110.95 50.0734 105.585C50.4991 105.017 50.9531 104.492 51.5775 103.712L51.5633 103.683Z",
    fill: "url(#paint1_linear_121_60137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.897 31.1034C134.133 29.8829 139.327 28.5062 144.606 27.4702C152.538 25.9374 160.555 25.0716 168.643 25.0007C173.07 24.9581 175.057 26.9167 175 31.3305C174.816 44.5437 172.701 57.4588 168.998 70.1185C168.913 70.4307 168.757 70.7288 168.7 70.8849C155.517 57.7001 142.307 44.5011 128.912 31.1034H128.897Z",
    fill: "url(#paint2_linear_121_60137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5035 125.284C53.9329 135.729 64.2489 146.09 74.6926 156.55C68.0518 161.73 60.9569 165.846 52.8403 168.06C47.5192 169.507 42.1412 170.047 36.6782 169.025C33.0456 168.344 31.6124 166.939 30.9739 163.291C29.484 154.918 31.3286 147.055 34.72 139.462C36.9904 134.381 39.956 129.712 43.5176 125.27L43.5035 125.284Z",
    fill: "url(#paint3_linear_121_60137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.106 75.0566C121.505 75.0708 124.939 78.5338 124.953 82.9476C124.953 87.4041 121.405 90.8954 116.936 90.8528C112.594 90.8103 109.131 87.2338 109.16 82.8625C109.188 78.4912 112.707 75.0424 117.106 75.0708V75.0566Z",
    fill: "url(#paint4_linear_121_60137)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_60137",
    x1: 111.654,
    y1: 35.6484,
    x2: 111.654,
    y2: 141.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_60137",
    x1: 80.4671,
    y1: 64.3701,
    x2: 80.4671,
    y2: 175.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_60137",
    x1: 151.949,
    y1: 25,
    x2: 151.949,
    y2: 70.8849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_60137",
    x1: 52.5726,
    y1: 125.27,
    x2: 52.5726,
    y2: 169.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_60137",
    x1: 117.056,
    y1: 75.0566,
    x2: 117.056,
    y2: 90.8532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_60137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketLaunch);
export default __webpack_public_path__ + "static/media/Market_Launch.afd7bdd4d92c7fdcfb119dc9f5b84555.svg";
export { ForwardRef as ReactComponent };